// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
const whitespaceSharedStyles = css({
  wordWrap: 'break-word',
  whiteSpace: 'pre-wrap'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export { whitespaceSharedStyles };